import React from 'react';
import { Star } from 'lucide-react';
export interface Testimonial {
  name: string;
  text: string;
  date?: string;
  avatar?: string;
}
export interface TestimonialsProps {
  testimonials?: Testimonial[];
  title?: string;
  subtitle?: string;
  eyebrow?: string;
  reviewCount?: number;
  googleReviewsUrl?: string;
  'data-id'?: string;
}
const defaultTestimonials: Testimonial[] = [{
  name: 'Beth Bylsma',
  date: 'October 2025',
  text: 'Bubbles and Gelato who would have thought. Girls weekend and this topped it off, not only was the experience outstanding, so was the wine, gelato and staff. This is a fantastic experience to add to your hunter weekend away.'
}, {
  name: 'Abigail Barnes',
  date: 'October 2025',
  text: "We recently had lunch for my wife's 50th birthday and the staff at Cuvee were excellent. Very accommodating and attentive. We will definitely be returning."
}, {
  name: 'C Lloyd',
  date: 'September 2025',
  text: 'Beautiful and genuine service. Breakfast at 10am was delicious and the sparkling wine was lovely! Great way to end our last day in the hunter. Lovely ambience!'
}];
export const Testimonials: React.FC<TestimonialsProps> = ({
  testimonials = defaultTestimonials,
  title = 'What Our Guests Say',
  subtitle = 'Discover why wine enthusiasts from around the world choose our vineyard for unforgettable experiences.',
  eyebrow = 'Testimonials',
  reviewCount = 1308,
  googleReviewsUrl = 'http://search.google.com/local/writereview?placeid=ChIJAQAAAACQDGsR7gpK2d2levU',
  'data-id': dataId
}) => {
  return <section className="bg-white py-16 md:py-24" data-id="element-298">
      <div className="max-w-7xl mx-auto px-6 lg:px-20" data-id="element-299">
        <div className="text-center mb-12" data-id="element-300">
          <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-301" />
          <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-302">
            {eyebrow}
          </div>
          <h2 className="font-heading text-4xl font-normal text-neutral-900 mb-6" data-id="element-303">
            What Our Visitors Are Saying
          </h2>

          {/* Google Reviews Badge */}
          <a href="http://search.google.com/local/writereview?placeid=ChIJAQAAAACQDGsR7gpK2d2levU" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-white border border-neutral-200 px-6 py-3 hover:border-brand-pink transition-colors group" data-id="element-304">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-305">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-306" />
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-307" />
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-308" />
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-309" />
            </svg>
            <div className="text-left" data-id="element-310">
              <div className="flex items-center gap-1 mb-1" data-id="element-311">
                {[...Array(4)].map((_, i) => <Star key={i} className="w-3 h-3 text-yellow-400 fill-yellow-400" data-id="element-312" />)}
                <Star className="w-3 h-3 text-yellow-400 fill-yellow-400" style={{
                clipPath: 'inset(0 50% 0 0)'
              }} data-id="element-313" />
              </div>
              <p className="text-xs text-neutral-600 group-hover:text-brand-pink transition-colors" data-id="element-314">
                {reviewCount.toLocaleString()} reviews on Google
              </p>
            </div>
          </a>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-315">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white border border-neutral-200 rounded-none p-8" data-id="element-316">
              {/* Name and Date */}
              <div className="mb-6" data-id="element-317">
                <h3 className="font-heading font-normal text-neutral-900" data-id="element-318">
                  {testimonial.name}
                </h3>
                {testimonial.date && <p className="text-xs text-neutral-500 mt-1" data-id="element-319">
                    {testimonial.date}
                  </p>}
              </div>
              {/* Rating */}
              <div className="flex gap-1 mb-4" data-id="element-320">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-brand-pink fill-brand-pink" data-id="element-321" />)}
              </div>
              {/* Testimonial text */}
              <p className="text-neutral-600 leading-relaxed" data-id="element-322">
                "{testimonial.text}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};